import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";
import { formatCurrency } from "../utils/orderDetailsUtils";
import { getLocalizedText } from "../../../../../utils/multilingualUtils";

const OrderItemsTable = ({ order }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    return (
        <div className="order-items-section">
            <h2>{t('orderItems')}</h2>
            <div className="order-items-table-container">
                <table className="order-items-table">
                    <thead>
                        <tr>
                            <th>{t('product')}</th>
                            <th>{t('variant')}</th>
                            <th>{t('price')}</th>
                            <th>{t('quantity')}</th>
                            <th>{t('total')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {order.items &&
                            order.items.map((item, index) => (
                                <tr key={index}>
                                    <td className="product-cell">
                                        {item.image && (
                                            <img
                                                src={item.image}
                                                alt={getLocalizedText(item.name, language)}
                                                className="product-thumbnail"
                                            />
                                        )}
                                        <span className="product-name">{getLocalizedText(item.name, language)}</span>
                                    </td>
                                    <td>
                                        {item.displayVariant ? (
                                            <div className="variant-info">
                                                <span>{item.displayVariant}</span>

                                            </div>
                                        ) : (
                                            <span>{t('dateNotAvailable')}</span>
                                        )}
                                    </td>
                                    <td>
                                        {order.currency} {formatCurrency(item.price)}
                                    </td>
                                    <td>{item.quantity}</td>
                                    <td>
                                        {order.currency}{" "}
                                        {formatCurrency(parseFloat(item.price) * item.quantity)}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="4" className="text-right">
                                {t('subtotal')}
                            </td>
                            <td>
                                {order.currency} {formatCurrency(order.subtotal)}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4" className="text-right">
                                {t('shippingCost')}({order.shipping?.method || t('dateNotAvailable')})
                            </td>
                            <td>
                                {order.currency}{" "}
                                {formatCurrency(order.shipping?.cost || 0)}
                            </td>
                        </tr>
                        {((order.discount && order.discount > 0) || (order.discountAmount && order.discountAmount > 0) || (order.promoCode?.discountAmount && order.promoCode.discountAmount > 0)) && (
                            <tr>
                                <td colSpan="4" className="text-right">
                                    {t('discount')}
                                    {order.promoCode?.code && ` (${order.promoCode.code})`}
                                </td>
                                <td className="discount-amount">
                                    -{order.currency} {formatCurrency(order.discount || order.discountAmount || order.promoCode?.discountAmount || 0)}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td colSpan="4" className="text-right">
                                {t('tax')}
                            </td>
                            <td>
                                {order.currency} {formatCurrency(order.tax?.amount) || "0.00"}
                            </td>
                        </tr>
                        <tr className="total-row">
                            <td colSpan="4" className="text-right">
                                {t('total')}
                            </td>
                            <td>
                                {order.currency} {formatCurrency(order.total)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default OrderItemsTable;